'use client'

import { useEffect, useRef, useState } from 'react'

const SP_BREAKPOINT = 768

export interface UseResponsiveBreakpointReturn {
  isSP: boolean
}

export function useResponsiveBreakpoint(): UseResponsiveBreakpointReturn {
  const [isSP, setIsSP] = useState(false)
  const resizeTimerRef = useRef<ReturnType<typeof setTimeout>>(undefined)

  useEffect(() => {
    const handleResize = () => {
      clearTimeout(resizeTimerRef.current)
      resizeTimerRef.current = setTimeout(() => {
        setIsSP(window.innerWidth < SP_BREAKPOINT)
      }, 150)
    }
    setIsSP(window.innerWidth < SP_BREAKPOINT)
    window.addEventListener('resize', handleResize)
    return () => {
      window.removeEventListener('resize', handleResize)
      clearTimeout(resizeTimerRef.current)
    }
  }, [])

  return { isSP }
}
